import { useCallback, useMemo } from 'react';

import { SlidingTabs } from '@/components/atoms/tabs';

export type HandoffDetailTab = 'activity' | 'customer';

interface HandoffDetailTabsProps {
  readonly activeTab: HandoffDetailTab;
  readonly activityLabel: string;
  readonly customerLabel: string;
  readonly onSelect: (tab: HandoffDetailTab) => void;
  readonly testID?: string;
}

export const HandoffDetailTabs = ({
  activeTab,
  activityLabel,
  customerLabel,
  onSelect,
  testID = 'handoff-detail-tabs',
}: HandoffDetailTabsProps) => {
  const items = useMemo(
    () => [
      { key: 'activity', label: activityLabel },
      { key: 'customer', label: customerLabel },
    ],
    [activityLabel, customerLabel],
  );

  const handleSelect = useCallback(
    (key: string) => {
      onSelect(key as HandoffDetailTab);
    },
    [onSelect],
  );

  return (
    <SlidingTabs activeKey={activeTab} items={items} testID={testID} onSelect={handleSelect} />
  );
};
